import "core-js/modules/es.regexp.exec.js";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
export var isiOSDevice = function isiOSDevice() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};
export var isMobile = function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
export var isSafari = function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
export var getCurrentDeviceSize = function getCurrentDeviceSize() {
  if (window.innerWidth < BREAKPOINT.SMALL) return "mobile";
  if (window.innerWidth < BREAKPOINT.LARGE) return "tablet";
  return "desktop";
};